import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Moment } from 'moment';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';

export enum LivasStatuses {
  didntPickup = 2,
  interviewInOffice = 3,
  interviewRemote = 4,
  wontOffer = 6, // Nesiūlysime darbo
  currentlyNotActive = 18, // Šiuo metu neaktualu
  candidateWaitsOffer = 19, // Laukia pasiūlymo
  clientInterview = 14,
  healthCheckInProgress = 15,
  healthCheckCompleted = 16,
  waitingDecision = 35, // Laukiama sprendimo (staginge buvo 31 keičiam nes prode 35)

  trialDay = 26,

  cannotContact = 34, // Nepavyko susisiekti
  introducingToClient = 36,
  employedByClientStaffing = 20,
  employedByClientSelections = 27,
  employed = 17, // Dirba
  redirectedToWorkis = 25,
}

@Injectable({
  providedIn: 'root',
})
export class LivasService {
  prefix = `${environment.url}`;

  constructor(private http: HttpClient) {}

  getCompanyWithContracts(title, contractorId, country) {
    const url = `${this.prefix}/api/v1/livas/company_list/`;
    return this.http.get(url, {
      headers: this.getAuthHeaders(),
      params: { title, contractor: contractorId, country },
    });
  }

  getLivasEmployeeData(userId) {
    const url = `${this.prefix}/api/v1/livas/${userId}/user/`;
    return this.http.get(url, { headers: this.getAuthHeaders() });
  }

  getContactCountByLivasAdId(adId): Observable<{ total_count: number }> {
    const url = `${this.prefix}/api/v1/livas/contacts_count_by_ad/`;
    return this.http.get<{ total_count: number }>(url, {
      headers: this.getAuthHeaders(),
      params: { ad_id: adId },
    });
  }

  private getAuthHeaders() {
    return new HttpHeaders({
      Authorization: `Bearer ${localStorage.getItem('token')}`,
    });
  }
}
